import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'sv',
    backend: {
      loadPath: `locales/{{lng}}/{{ns}}.json`,
      requestOptions: {
        cache: 'no-store',
      },
    },
    ns: ['main', 'errors', 'possession', 'notifications', 'rental'],
    defaultNS: 'main',
    debug: false,
    parseMissingKeyHandler: (key) => {
        console.warn(`Key "${key}" not found.`);

        return key;
    }
  });

export default i18n;
